<template>
  <div class="page-table" :class="className">
    <el-table
      class="st__table"
      v-bind="$attrs"
      ref="elTable"
      style="width: 100%"
      :height="height"
      :max-height="maxHeight"
      v-loading="pagerConfig.loading"
      border
      highlight-current-row
      :data="data"
      @selection-change="handleSelectionChange"
      @select="handleSelectEvt"
      @select-all="handleSelectAllEvt"
      @current-change="handleSelectRow"
      :row-key="rowKey"
      :header-row-style="{ height: '50px', color: '#606266' }"
      :span-method="spanMethod || ''"
      default-expand-all
    >
      <!-- 嵌套表格不共用header -->
      <el-table-column v-if="expandColumns.length" type="expand">
        <template v-slot="{ row }">
          <el-table
            v-if="row.children"
            border
            size="mini"
            :data="row.children"
            style="width: 100%"
          >
            <el-table-column
              v-for="(item, index) in expandColumns.filter(
                (item) => !item.hidden,
              )"
              header-align="center"
              :key="index"
              :prop="item.value"
              :label="item.label"
              :fixed="item.fixed"
              :align="item.align || 'center'"
              :width="item.width"
              :min-width="item.minWidth || '100px'"
            >
              <template v-slot="scope">
                <!-- slot -->
                <template v-if="item.type === 'slot'">
                  <slot
                    :name="'col-' + item.value"
                    :row="scope.row"
                    :item="item"
                  />
                  <slot
                    name="dy-query-col"
                    :data="{ row: scope.row, item: item }"
                  />
                </template>
                <!-- pipe -->
                <span v-else-if="item.type === 'pipe'">{{
                  $options.filters[item.pipe](
                    scope.row[item.value],
                    item.pipeArg || '',
                  )
                }}</span>
                <!-- default -->
                <span v-else>{{ scope.row[item.value] }}</span>
              </template>
            </el-table-column>
            <!-- handle -->
            <el-table-column
              v-if="expandHandle"
              :key="'handle'"
              :fixed="expandHandle.fixed"
              align="center"
              :label="expandHandle.label"
              :width="expandHandle.width"
            >
              <template v-slot="scope">
                <!-- {{scope}} -->
                <template v-for="(item, index) in expandHandle.btns || []">
                  <!-- 自定义操作类型 -->
                  <slot
                    v-if="item.slot"
                    :name="'bt-' + item.event"
                    :data="{ item, row: scope.row }"
                  />
                  <!-- -->
                  <slot
                    v-if="item.slot"
                    name="dy-query-btn"
                    :data="{ item, row: scope.row }"
                  />
                  <!--  -->
                  <el-button
                    v-if="
                      !item.slot && (!item.ifRender || item.ifRender(scope.row))
                    "
                    :key="index"
                    size="mini"
                    :type="item.type"
                    :icon="item.icon"
                    :disabled="item.disabled"
                    :class="item.class"
                    @click.stop="
                      handleClick(item.event, scope.row, scope.$index, row)
                    "
                    >{{ item.label }}</el-button
                  >
                </template>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <!--多选-->
      <el-table-column
        v-if="checkBox"
        :key="'selection'"
        type="selection"
        width="55px"
        :selectable="selectable"
      />
      <!--单选-->
      <el-table-column
        label="选择"
        v-if="radioCheck"
        width="55"
        header-align="center"
        align="center"
        :fixed="columns.some((item) => item.fixed)"
      >
        <template slot-scope="scope">
          <el-radio class="radio" v-model="radio" :label="scope.$index"
            >&nbsp;</el-radio
          >
        </template>
      </el-table-column>
      <!-- tabIndex -->
      <el-table-column
        v-if="tabIndex"
        :key="'index'"
        align="center"
        label="序号"
        :width="columns.length === 0 ? '' : 80"
        :fixed="columns.some((item) => item.fixed)"
      >
        <template v-slot:header="scope" v-if="exportExcel">
          <el-popover trigger="hover" placement="top">
            <span slot="reference"> <i class="el-icon-document"></i>序号 </span>
            <el-row style="text-align: center; width: 150px">
              <el-button
                size="small"
                type="primary"
                icon="document"
                v-loading="downloadLoading"
                @click="handleDownload"
                >导出</el-button
              >
            </el-row>
          </el-popover>
        </template>
        <template v-slot="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <!-- handle -->
      <el-table-column
        v-if="handle"
        :key="'handle'"
        :fixed="handle.fixed"
        align="center"
        :label="handle.label"
        :width="handle.width"
      >
        <template v-slot="scope">
          <template v-for="(item, index) in handle.btns || []">
            <!-- 自定义操作类型 -->
            <slot
              v-if="item.slot"
              :name="'bt-' + item.event"
              :data="{ item, row: scope.row, $index: scope.$index }"
            />
            <!-- -->
            <slot
              v-if="item.slot"
              name="dy-query-btn"
              :data="{ item, row: scope.row, $index: scope.$index }"
            />
            <!--  -->
            <el-button
              v-if="!item.slot && (!item.ifRender || item.ifRender(scope.row))"
              :key="index"
              size="mini"
              :type="item.type"
              :icon="item.icon"
              :disabled="item.disabled"
              :class="item.class"
              @click.stop="handleClick(item.event, scope.row, scope.$index)"
              >{{ item.label }}</el-button
            >
          </template>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in columns.filter((item) => !item.hidden)"
        header-align="center"
        :key="index"
        :prop="item.value"
        :label="item.label"
        :fixed="item.fixed"
        :align="item.align || 'center'"
        :width="item.width"
        :min-width="item.minWidth || '100px'"
        :show-overflow-tooltip="item.showOverflowTooltip || false"
      >
        <!-- header 自定义气泡 -->
        <template #header="scope">
          <template v-if="item.headerType === 'slot'">
            <slot :name="'header-' + item.value" :item="item" />
            <slot name="dy-query-header" :data="{ item: item }" />
          </template>
          <el-popover
            v-else-if="item.header_bubble"
            trigger="hover"
            placement="top"
            :width="300"
          >
            <span slot="reference">
              {{ item.label }}
              <i class="el-icon-warning"></i>
            </span>
            <span>{{ item.header_bubble_text }}</span>
          </el-popover>
          <template v-else>{{ item.label }}</template>
        </template>
        <!-- col -->
        <template #default="scope">
          <!-- 父级指定模板 自定义 -->
          <template v-if="item.type === 'slot'">
            <slot
              :name="'col-' + item.value"
              :row="scope.row"
              :item="item"
              :$index="scope.$index"
            />
            <slot
              name="dy-query-col"
              :data="{ row: scope.row, item: item, $index: scope.$index }"
            />
          </template>
          <!-- 嵌套表格 -->
          <template v-else-if="item.children">
            <el-table-column
              v-for="(childItem, childIndex) in item.children"
              :key="childIndex"
              :prop="childItem.value"
              :label="childItem.label"
              align="center"
              :width="item.width"
              :min-width="item.minWidth || '85px'"
            />
          </template>
          <!-- pipe -->
          <span
            v-else-if="item.type === 'pipe'"
            :style="calcuRowColor(item.color)"
          >
            {{
              $options.filters[item.pipe](
                scope.row[item.value],
                item.pipeArg || '',
              )
            }}
          </span>
          <!-- popover-->
          <el-popover
            v-else-if="item.type === 'popover'"
            trigger="hover"
            placement="top"
          >
            <p class="text-c">{{ scope.row[item.value] }}</p>
            <span slot="reference" class="dy-table-popover">
              {{ scope.row[item.value] }}
            </span>
          </el-popover>
          <!-- image -->
          <el-image
            v-else-if="item.type === 'image' && scope.row[item.value]"
            fit="contain"
            style="width: 60px; height: 60px"
            :src="scope.row[item.value]"
            :preview-src-list="[scope.row[item.value]]"
          />
          <!-- tag -->
          <el-tag v-else-if="item.type === 'tag'">{{
            scope.row[item.value]
          }}</el-tag>
          <!-- id2name  _id2name-->
          <!-- <span v-else-if="item.type === 'id2name'">
            <el-tag v-if="item.subtype === 'tag'">{{ scope.row[item.value+'_id2name'] }}</el-tag>
            <el-image v-else-if="item.subtype === 'image' && scope.row[item.value+'_id2name']" fit="contain" style="width:60px;height:60px;" :src="scope.row[item.value+'_id2name']" :preview-src-list="[scope.row[item.value+'_id2name']]" />
            <template v-else>{{ scope.row[item.value+'_id2name'] }}</template>
          </span> -->
          <!-- time -->
          <span v-else-if="item.type === 'time'">{{
            scope.row[item.value] | parseTime
          }}</span>
          <!-- boolean -->
          <span
            v-else-if="item.type === 'boolean'"
            :style="calcuRowColor(item.color)"
            >{{ scope.row[item.value] ? '是' : '否' }}</span
          >
          <!-- default -->
          <span v-else :style="calcuRowColor(item.color)">{{
            scope.row[item.value]
          }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!--  -->
    <template v-if="pager">
      <div
        v-show="!pagerConfig.loading && data.length"
        class="text-c"
        style="margin-top: 20px"
      >
        <span class="dy-record__selected flt" v-show="selectedRecordCount">
          已选{{ selectedRecordCount }}条记录 &nbsp;&nbsp;
          <el-button
            v-if="recordViewSchema"
            type="text"
            size="small"
            @click="$emit('viewSelectedRows')"
            >查看已选产品</el-button
          >
        </span>
        <el-pagination
          class="inlineBlock"
          background
          :current-page.sync="pagerConfig.query.curPage"
          :page-sizes="pagerConfig.pageSizes"
          :page-size="pagerConfig.query.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagerConfig.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </template>
  </div>
</template>

<script>
/**
 * created by 3shaoye 2020/07/10
 */
import request from '@/utils/request'
import { deepClone, isLegalKey, debounce } from '@/utils/index'
import Sortable from 'sortablejs'
import async from 'async'
export default {
  name: 'dynamic-table',
  props: {
    // 自定义类名
    className: {
      type: String,
      default: '',
    },
    // 表格字段配置
    columns: {
      type: Array,
      default: () => [],
    },
    // 嵌套表格的配置
    expandColumns: {
      type: Array,
      default: () => [],
    },
    // 列表数据
    data: {
      type: Array,
      default: () => [],
    },
    // 是否显示序号
    tabIndex: {
      type: Boolean,
      default: false,
    },
    // 是否有选择框
    checkBox: {
      type: Boolean,
      default: false,
    },
    //selectable 仅对 type=selection 的列有效   Function(row, index)
    selectable: {
      type: Function,
      default: null,
    },
    // 是否开启查看record功能  如不设置checkBox 也不生效
    recordView: {
      type: Boolean,
      default: false,
    },
    selectedRecordCount: {
      type: Number,
      default: 0,
    },
    //是否配置 recordViewSchema
    recordViewSchema: {
      type: Boolean,
      default: false,
    },
    //是否单选radio
    radioCheck: {
      type: Boolean,
      default: false,
    },
    // 操作栏配置
    handle: {
      type: Object,
      default: null,
    },
    // 嵌套表格操作栏
    expandHandle: {
      type: Object,
      default: null,
    },
    // 查询条件
    queryParams: {
      type: Object,
      default: () => ({}),
    },
    //首次请求带入的参数  因为sf匹配默认值时机不确定
    initialFormValue: {
      type: Object,
      default: () => ({}),
    },
    /** *分页 */
    pager: {
      type: Boolean,
      default: false,
    },
    //url  mothed
    requestOptions: {
      type: Object,
      default: null,
    },
    //格式化data
    formatData: {
      type: Function,
      default: (v) => v,
    },
    //行数据的 Key，用来优化 Table 的渲染；显示树形数据时，该属性是必填的。
    rowKey: {
      type: String,
      default: '',
    },
    //init checked data
    // [rowKey,value,vlaue]  ['productSkuId','45611213','456567412']
    alreadyCheckedList: {
      type: Array,
      default: () => [],
    },
    // Table 的高度，默认为自动高度。设置高度可以固定表头
    height: [Number, String],
    // 是否支持拖拽
    draggable: {
      type: Boolean,
      default: false,
    },
    //合并行列
    spanMethod: {
      type: Function,
      default: () => {},
    },
    //
    exportExcel: {
      type: Boolean,
      default: false,
    },
    // 限制表格高度  订单不需要
    limitMaxHeight: {
      type: Boolean,
      default: true,
    },
    // 默认init查询 当有校验条件时 必填等 默认不查询
    initQuery: {
      type: Boolean,
      default: true,
    },
    // 函数返回 promise  跟formatData方法有些冗余  特殊场景下用这个 也不冲突
    pipe: {
      type: Function,
      default: (v) => v,
    },
  },
  data() {
    return {
      TIMES: 0,
      radio: null,
      // 列表相关
      pagerConfig: {
        total: 0, // 总条数
        loading: false, // 加载动画
        pageSizes: [10, 20, 50, 100], // 分页数量列表
        query: {
          // 查询条件
          curPage: 1, // 当前页
          pageSize: 10, // 每页条数
        },
      },
      downloadLoading: false,
      maxHeight: null,
    }
  },
  computed: {
    data_length() {
      return this.data.length
    },
  },
  created() {
    this.initQuery && this.query()
  },
  mounted() {
    if (this.limitMaxHeight) {
      this.calculateMaxHeight()
      this.__resizeHandler = debounce(this.calculateMaxHeight, 100)
      window.addEventListener('resize', this.__resizeHandler)
    }
  },
  beforeDestroy() {
    this.$emit('update:data', [])
    this.limitMaxHeight &&
      window.removeEventListener('resize', this.__resizeHandler)
  },
  watch: {
    data_length: {
      handler(newVal, oldVal) {
        if (this.draggable && newVal != oldVal) {
          this.$nextTick(() => {
            this.setSort()
          })
        }
        if (newVal) {
          //formatData then id2name
          const _data = !(this.requestOptions && this.requestOptions.url)
            ? this.formatData(this.data)
            : this.data
          this.batchId2nameForTableData(_data, this.columns, false, (data) => {
            // this.$emit('update:data', data);
            // data = null;
            this.afterUpdateTableData()
          })
          this.$refs.elTable && this.$refs.elTable.doLayout()
        }
      },
      immediate: true,
    },
    draggable(value) {
      if (!value) {
        return this.sortable.destroy()
      }
      return value && this.data.length && this.setSort()
    },
  },
  methods: {
    loadId2nameForTableData() {
      const _data = this.formatData(this.data)
      this.batchId2nameForTableData(_data, this.columns, false, (data) => {
        this.afterUpdateTableData()
      })
    },
    calculateMaxHeight() {
      this.maxHeight =
        (document.body.clientHeight || document.documentElement.clientHeight) -
        80 -
        52 -
        50
      this.$nextTick(() => {
        this.$refs.elTable && this.$refs.elTable.doLayout()
      })
    },
    //当用户手动勾选数据行的 Checkbox 时触发的事件
    handleSelectEvt(selection, row) {
      if (this.recordView) {
        this.$emit('handleEvent', 'rowToggle', row)
      }
    },
    handleSelectAllEvt(selection) {
      if (this.recordView) {
        selection.length
          ? this.$emit('handleEvent', 'allToggleInRecordView', selection, true)
          : this.$emit('handleEvent', 'allToggleInRecordView', this.data)
      } else {
        this.$emit('handleEvent', 'tableCheck', selection)
      }
    },
    // 选中数据
    handleSelectionChange(rows) {
      if (!this.recordView) {
        this.$emit('handleEvent', 'tableCheck', rows)
      }
    },
    //单选行
    handleSelectRow(row) {
      if (!this.radioCheck) {
        return false
      }
      this.radio = row
      this.$emit('handleEvent', 'singleSelectRow', row)
    },
    // 派发按钮点击事件
    handleClick(event, row, $index) {
      this.$emit('handleClick', event, row, $index)
    },
    // 设置分页size
    handleSizeChange(val) {
      const query = this.pagerConfig.query
      query.pageSize = val // 每页条数
      query.curPage = 1 // 每页条数切换，重置当前页
      this.query()
    },
    // 跳转某一页
    handleCurrentChange(val) {
      this.pagerConfig.query.curPage = val // 当前页
      this.query()
    },
    // 动态请求st的queryParams
    handleParams(initialVal) {
      let obj = {}
      let { queryParams } = this
      for (const key in queryParams) {
        //hack cityId
        if (key == 'cityId' && Array.isArray(queryParams[key])) {
          queryParams[key] = queryParams[key].shift()
        }
        if (isLegalKey(queryParams[key])) {
          obj[key] = queryParams[key]
        }
      }
      return Object.assign(obj, initialVal)
    },
    //过滤st extraParams
    filterExtraParams(extraParams) {
      let params = {}
      for (let key in extraParams) {
        if (isLegalKey(extraParams[key])) {
          params[key] = extraParams[key]
        }
      }
      return params
    },
    // 动态请求st的data
    query() {
      if (
        !(this.requestOptions && this.requestOptions.url) ||
        this.pagerConfig.loading
      ) {
        return false
      }
      this.TIMES++
      this.$emit('update:data', [])
      this.pagerConfig.loading = true
      // 每次调用接口时都自动绑定最新的数据
      let { url, method, extraParams = {} } = this.requestOptions
      const { curPage, pageSize } = this.pagerConfig.query
      const initialVal = this.TIMES === 1 ? this.initialFormValue : {}
      const reqParams = this.handleParams(initialVal)
      const _extraParams = this.filterExtraParams(extraParams)
      const pager = {
        page: curPage,
        limit: pageSize,
      }
      const reqData = this.pager
        ? Object.assign({}, reqParams, _extraParams, pager)
        : Object.assign({}, reqParams, _extraParams)
      let dataKey = method.toLowerCase() == 'get' ? 'params' : 'data'
      // 兼容ssc
      //url = url + `?page=${curPage - 1}&size=${pageSize}`
      request({
        url,
        method,
        [dataKey]: reqData,
      })
        .then(async (res) => {
          console.log(res, '12312')
          if (res.data.code != 200) {
            this.$message({
              showClose: true,
              message: res.data.msg || '请求出错',
              type: 'error',
              duration: 3500,
            })
            this.pagerConfig.loading = false
            return
          }
          this.pagerConfig.loading = false
          // pipe
          const data =
            (await this.pipe(this.handleResponse(res))) ||
            this.handleResponse(res)
          this.$emit('update:data', this.formatData(data))
          // 兼容ssc
          // if (this.pager && res.pageable && res.content && res.totalElements > 0) {
          //   this.pagerConfig.total = +res.totalElements;
          //   this.pagerConfig.query.curPage = 1 + res.pageable.pageNumber;
          //   this.pagerConfig.query.pageSize = +res.pageable.pageSize;
          // } else
          if (this.pager && res.data.count > 0) {
            this.pagerConfig.total = +res.data.count
            //this.pagerConfig.query.curPage = +res.currentPage;
            //this.pagerConfig.query.pageSize = +res.pageSize;
          }
        })
        .catch((err) => {
          if (err) {
            this.$message({
              showClose: true,
              message: (err && err.message) || '请求出错',
              type: 'error',
              duration: 3500,
            })
          }
          this.pagerConfig.loading = false
        })
    },
    /***
     * 重新渲染data之后
     */
    afterUpdateTableData() {
      //hack  alreadyCheckedList
      const v =
        (this.checkBox || this.radioCheck) && this.alreadyCheckedList.length
      v &&
        this.$nextTick(() => {
          const rows = this.getAlreadyCheckedList(
            this.alreadyCheckedList.slice(),
          )
          if (this.radioCheck) {
            this.initCheckRadioRow(rows[0])
          } else {
            this.initToggleRowSelection(rows)
          }
        })

      //跨多分页选数据时，回显已经选中的rows
      this.recordView &&
        this.$nextTick(() => {
          const needSelectedRows = this.findSelectedRows(
            this.$parent.checkList || [],
            this.data,
            this.rowKey,
          )
          this.initToggleRowSelection(needSelectedRows)
        })

      !this.recordView && (this.$parent.checkList = [])

      this.draggable &&
        this.$nextTick(() => {
          this.setSort()
        })
    },
    handleResponse(response) {
      //兼容ssc
      if (response.content && response.pageable) {
        return response.content
      }
      if (Array.isArray(response)) {
        return response
      }
      if (Array.isArray(response.data.data)) {
        return response.data.data
      }
      return []
    },
    //reset
    reset() {
      this.pagerConfig.query.curPage = 1
      this.query()
    },
    // handle alreadyCheckedList
    // 匹配得到需要被选中的rows ['productSkuId','45611213','456567412']
    getAlreadyCheckedList() {
      const list = this.alreadyCheckedList.slice()
      const property = list.shift()
      const rows = []
      for (let value of list) {
        for (let item of this.data) {
          if (item[property] == value) {
            rows.push(item)
          }
        }
      }
      return rows
    },
    initCheckRadioRow(row) {
      this.radio = -1
      const rowKey = this.rowKey || 'id'
      const $index = this.data.findIndex(
        (item) => row && item[rowKey] == row[rowKey],
      )
      $index >= 0 && (this.radio = $index)
      this.$emit('handleEvent', 'singleSelectRow', row)
    },
    //  handle  alreadyCheckedList 选中alreadyCheckedList
    initToggleRowSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.elTable && this.$refs.elTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.elTable && this.$refs.elTable.clearSelection()
      }
    },
    // find 需回显的行
    findSelectedRows(checkList, tableData, rowKey) {
      const needSelectedRows = []
      for (let cItem of checkList) {
        for (let tItem of tableData) {
          if (tItem[rowKey] == cItem[rowKey]) {
            needSelectedRows.push(tItem)
          }
        }
      }
      return needSelectedRows
    },
    // 为default-row添加色值
    calcuRowColor(colorType) {
      const colrMap = {
        success: '#67C23A',
        warning: '#E6A23C',
        danger: '#409eff',
        theme: '#409EFF',
      }
      return { color: colrMap[colorType] || 'inherit' }
    },
    // draggable
    setSort() {
      const el = this.$refs.elTable.$el.querySelectorAll(
        '.el-table__body-wrapper > table > tbody',
      )[0]
      this.sortable = Sortable.create(el, {
        ghostClass: 'sortable-ghost',
        setData: function (dataTransfer) {
          dataTransfer.setData('Text', '')
        },
        onEnd: (evt) => {
          const targetRow = this.data.splice(evt.oldIndex, 1)[0]
          this.data.splice(evt.newIndex, 0, targetRow)
        },
      })
    },
    //export excel  columns
    async handleDownload() {
      if (!this.data.length || this.downloadLoading) return false
      this.downloadLoading = true
      const excel = await import('@/vendor/Export2Excel')
      const { tHeader, tHeader_filterVal } = this.getExcelParams(this.columns)
      this.batchId2nameForTableData(this.data, this.columns, true, (data) => {
        const _data = this.formatJson(tHeader_filterVal, data)
        excel.export_json_to_excel({
          header: tHeader,
          data: _data,
          filename: 'list-xlsx',
          autoWidth: true,
          bookType: 'xlsx',
        })
        this.downloadLoading = false
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]))
    },
    getExcelParams(columns) {
      const tHeader = columns.map((col) => col.label)
      const tHeader_filterVal = columns.map((col) => col.value)
      return { tHeader, tHeader_filterVal }
    },
    batchId2nameForTableData(tableData, columns, forExcel, cb) {
      const _tableData = forExcel ? deepClone(tableData) : tableData // 导出的 直接赋值
      let _this = this
      const id2name_items = columns
        .map((item) => {
          if (item.type === 'id2name') {
            return {
              rowKey: item.value,
              id2name_code: item.id2name_code,
              mdDic: !!item.mdDic,
            }
          }
          return null
        })
        .filter(Boolean)

      // 区分新网关
      const newGatewayCodes = ['BizUserTag', 'productCategory', 'productBrand']
      const tasks = []
      id2name_items.forEach((obj) => {
        let { rowKey, id2name_code, mdDic } = obj
        let data = _tableData
          .map((item) => item[rowKey])
          .filter((v) => v || v === 0)
        data = Array.prototype.concat
          .apply([], data)
          .filter((v) => /[0-9]/g.test(v)) //扁平化数组
        mdDic && (id2name_code = `dictionary?code=${id2name_code}`)
        let url = `/id2name/trans/${id2name_code}`
        if (newGatewayCodes.includes(id2name_code)) {
          url = '/newGateway' + url
        }
        tasks.push((callback) => {
          request({
            url,
            method: 'POST',
            data: [...new Set(data)],
          })
            .then((kvObj) => {
              for (let row of _tableData) {
                if (forExcel) {
                  if (Array.isArray(row[rowKey])) {
                    row[rowKey] = row[rowKey].map((t) => kvObj[t]).join(',')
                  } else {
                    row[rowKey] = kvObj[row[rowKey]]
                  }
                } else {
                  if (Array.isArray(row[rowKey])) {
                    _this.$set(
                      row,
                      [rowKey + '_id2name'],
                      row[rowKey].map((t) => kvObj[t]).join(','),
                    )
                  } else {
                    _this.$set(row, [rowKey + '_id2name'], kvObj[row[rowKey]])
                  }
                }
              }
              callback(null)
            })
            .catch((err) => {
              callback(null)
            })
        })
      })
      async.parallel(tasks, (err, result) => {
        cb(_tableData)
      })
    },
  },
}
</script>

<style lang="scss">
.page-table {
  margin-top: 20px;
}

.st__table .el-table__expanded-cell {
  padding: 10px 50px;
}

.dy-table-popover {
  display: block;
  margin: auto;
  width: 120px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dy-record__selected {
  font-size: 13px;
  line-height: 28px;
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// DyTable.vue?14481318